import { RIGHT_ARROW } from "../lib/assets";

export const FEATURE_TWO_LIST = [
  {
    id: 1,
    icon: "flaticon-profit",
    title: "I don't know where to start",
    subtitle: "We set up your books and software for you, step by step.",
  },
  {
    id: 2,
    icon: "flaticon-investment",
    title: "My personal and business money is mixed",
    subtitle: "We separate it properly and show you how to keep it clean.",
  },
  {
    id: 3,
    icon: "flaticon-taxes",
    title: "I'm worried about CRA and tax time",
    subtitle: "Your records stay organized and ready for your tax preparer.",
  },
];

export const FEATURE_THREE_LIST = [
  {
    id: 1,
    title: "Finance Planning",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 2,
    title: "Business Consulting",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 3,
    title: "Tax Advisory",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 4,
    title: "Business Audit",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
];

export const FEATURE_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-life-insurance",
    title: "More coverage",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 2,
    icon: "flaticon-handshake",
    title: "Less hassle",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 3,
    icon: "flaticon-money",
    title: "Faster benefits",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
];

export const FEATURE_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-puzzle-piece",
    title: "Quality Services",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 2,
    icon: "flaticon-inspiration",
    title: "Innovation Ideas",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 3,
    icon: "flaticon-profit",
    title: "Business Growth",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
];
